declare let process: {
  env: {
    REACT_APP_APPINS_CONNECTION_STRING: string;
  };
};
export const appInsightsConnectStr: string = process.env.REACT_APP_APPINS_CONNECTION_STRING;
export const portalURL: string = 'https://onemap-eaa.bpglobal.com/portal';
export const appId: string = 'y3a2SRrgB0AX5fLL';
